import { ProcessPath } from "./types/processPath";
import { ProcessPathToActivityCsv } from "./types/processPathToActivityCsv";
import { Site } from "./types/site";
import { SiteCsv } from "./types/siteCsv";
import { SiteToProcessPathCsv } from "./types/siteToProcessPathCsv";

class AssessmentVideoInfoService {
    constructSiteData(processPathToActivities: ProcessPathToActivityCsv[], siteToProcessPaths: SiteToProcessPathCsv[], sites: SiteCsv[]) : Site[]{
        const processPathToActivityMap = processPathToActivities.reduce((processPathToActivityMap: Map<string, string[]>, currentProcessPathToActivity: ProcessPathToActivityCsv) => {
            if(processPathToActivityMap.has(currentProcessPathToActivity.processPath)) {
                processPathToActivityMap.get(currentProcessPathToActivity.processPath)!.push(currentProcessPathToActivity.activity);
            } else {
                processPathToActivityMap.set(currentProcessPathToActivity.processPath, [currentProcessPathToActivity.activity]);
            }
            return processPathToActivityMap;
        }, new Map<string, string[]>());

        const siteToProcessPathMap = siteToProcessPaths.reduce((siteToProcessPathMap: Map<string, ProcessPath[]>, currentSiteToProcessPath: SiteToProcessPathCsv) => {
            if(siteToProcessPathMap.has(currentSiteToProcessPath.site)) {
                let processPathActivities = siteToProcessPathMap.get(currentSiteToProcessPath.site);
                processPathActivities!.push({
                    name: currentSiteToProcessPath.processPath,
                    activities: processPathToActivityMap.get(currentSiteToProcessPath.processPath) ?? []
                });
            } else {
                siteToProcessPathMap.set(currentSiteToProcessPath.site, [{
                    name: currentSiteToProcessPath.processPath,
                    activities: processPathToActivityMap.get(currentSiteToProcessPath.processPath) ?? []
                }]);
            }
            return siteToProcessPathMap;
        }, new Map<string, ProcessPath[]>())

        const siteMap = sites.reduce((siteMap: Map<string, Site>, currentSite: SiteCsv) => {
            siteMap.set(currentSite.site, {
                name: currentSite.site,
                processPaths: siteToProcessPathMap.get(currentSite.site) ?? [],
                organization: currentSite.org,
                subOrganization: currentSite.suborg,
                siteType: currentSite.siteType,
                region: currentSite.region,
                country: currentSite.country
            });
            return siteMap;
        }, new Map<string, Site>());

        let sortedSites = this.sortSitesData([...siteMap.values()]);
        return sortedSites;
    }

    sortSitesData(sitesData: Site[]) {
        // This sorts alphabetically
        // 1. The activities for each process path within a site
        // 2. The process paths for each site based on process path name
        // 3. The actual site based on site name
        let sortedSites = sitesData.map((site) => {
            site.processPaths = site.processPaths.map((processPath) => {
                processPath.activities.sort((a, b) => a.localeCompare(b));
                return processPath;
            });
            site.processPaths.sort((a, b) => a.name.localeCompare(b.name));
            return site;
        });
        sortedSites.sort((a, b) => a.name.localeCompare(b.name));

        return sortedSites;
    }
}

export default new AssessmentVideoInfoService();
